export const formStatuses = {
  Unassigned: 'b28842d9ad2641338faeead81752dd27',
  InactiveMembers: '70ab0a4e56f14072893c608b830aa6dc',
  TransferOut: 'f05b1160c6e245cd9c5ff2542fe2ccf7',
  ActiveMembers: 'f4f4ee067e3d4ab0b8ede6627e4ab0ac',
  DuesForm: '622be9722edf4de4b2b66e0e40bbeeef',
  NotStarted: '83434fd0ce264fe09a424596823e80f2',
};

export const formStates = {
  LCTreas: 'c15526c2aebb4713865745ad0ae959c7',
  LCPres: '3e0315958276403bbe2697f83e49e434',
  SpdTreas: 'd7da036b82af4f27b221e1754601dd20',
  SpdSec: '188da6218c6e4e329ce2e6b11b1c7a57',
  SpdExec: '718f31ce9ebb45319b5d9862bd56d96a',
  SpdPres: 'fdd32de02b1c45dbacacae67bd439275',
  Completed: 'a035d8b411774ebfadfc8d3ee1d703f2',
};

export const irsStates = {
  LCTreas: 'd8a0127a9fed426492205fabddc6ef7d',
  LCPres: '9b5971f8fd7047958ffc156e4a2efb55',
  SpdTreas: '9fb1ea53c7b44c33acef63a86484f82d',
  Completed: 'd0bfc717b2e64d098a27507345cf267a',
};

export const memberStatuses = {
  Unassigned: '0fac81ac43094fccae6264c6a76f51e7',
  Inactive: 'bbcd1dfce5a449fba82f7d3e131c4a08',
  Active: '2efc683e8d4a4b7bbdb700f27c18ee08',
  Other: '2ae99ae943064a638aa8fb1806e16ce7',
  NoProcessing: 'a8a813a5c5b04470a102791fc6107b15',
};

export const receiptQuestions = {
  question1: 'c2d10e6c39bf4b84b728aa0e6324746e',
  question2: '77bdefb130884ca2af352ca3e80f8ee3',
  subQuestion3: 'eafd00006a064224966088c3b59384f0',
  subQuestion4: '0b530ad12c604169a7b2e36218bf3677',
  question3: '4f19da96a310482ab27cc4c85aa919de',
  question7: '4bab454f0fc04da9baf0592c10016618',
  question8: 'b4b75e42cc724f39a3adf85c6b4d3bcd',
  question9: '27b665b2aead4f2f915339640601d38c',
  question10: '2aa92f4b9d1140e7b4160c0ab4220f08',
};

export const disbursementQuestions = {
  question0: '14f5fd664fb64f80ab2d76c3dd92b9ec',
  question1: '04eacf562cb24a2bad38630a58fe1a2d',
  question2: 'ef17ef2ed43145618c34fcd2f25926d3',
  question3: '58d97ad6560245bdb4eb7d3a64c7a87f',
  question4: 'd64c8ca603e146899f5394bd25f819fa',
  question5: '9b851331d4e54e6485e4036581a80c19',
  subQuestion3: '9b8835fdfbd44ce792332be2bcf446cc',
  subQuestion4: '9716d7bdd8514fb49e94f082afef6c95',
  question6: '7ffbeb17f21140a4b0140787e4ac3821',
  question9: 'c07551a1eccc4168b74f43ee275ac5e0',
  question10: 'b21d13cf442743128759438d57d33e05',
};

export const assetQuestions = {
  question1: 'bb0c5672578c479c854c8e17b00714cf',
  question3: '468289cd36904f109f773fa1327bd153',
  question4: 'a970c5d2f2264c4a88cca4545b7a138d',
  question5: '46987ef3b44f48359032a2f15d3a2d1d',
  question6: '15e5e73ebb9a47398a73ffb3c5f4e47c',
  question7: '67ff33369da145adb77ec5f48fd18120',
};

export const applications = {
  DocumentAdmin: '1318b71740ac4264823f5e1f9d4bb189',
  TrainingAdmin: '511207ced22e452cb9148c26bcbcae61',
  UserManagement: '5632faa767544d41b49307a34a953459',
  AnnualReportAdmin: '6485c3cb78f946b391ab2fd6f894522b',
  ExecAppBar: 'a6bed255bd9e46228b257235b4250aeb',
  SupportAdmin: 'b3e622d7c28841a694baa95deea762d8',
  BetaUser: 'c0e4a6e0f5b94d4c8b9f2d9c3f1f0b0b',
  MessageAdmin: 'b0803d13c9d34e5a9486ae18b0966672',
  MessageApprover: '8dc3dc1ed04a40ba87ba96a71190633c',
  DonationsViewer: 'f23ff148b99549959caade0302c27850',
  FeedbackAdmin: '1e1f1d0977ee4abf8905371bee469a65',
  PermissionsAdmin: '98b4a3f29a994c64b660898aa4b92a58',
  SeekingTransferAdmin: '164b254df558473286cc30477326bae3',
  PCE: '5fae9acbe116443694deea4c10a820e6',
  Foundations: 'e86acbadee1b4b34bcc2556706b89b88',
};

export const projects = {
  Foundations: 'd715cd09d85844039ba4807c991232c2',
  ELF: '134fcb458f1a447fb6854393e4d4ffd3',
  IPS: '2385c3c477c54329b2afbe3a6c7f432b',
  PCE: 'a3329a35021f4db1b9608945f5b501df',
  PSA: 'aa9e8eb796734e2887f3d92fa211f77c',
  STAR: 'f7369bfc19a24558ada0a77f3f740dd2',
  Cottey: '12redirect21',
};

export const roles = {
  Support: '04a1d0a6f0884bcfb44911c2eaa5b77f',
  Member: '17498438bae2433595431cc7f273a960',
  Finance: '21160e65fd7243c49023aad41be8b084',
  SPDOfficer: '2ed5b967133e41febd61998477e018bb',
  RMR: '6b128d199aa04f99b362cff974958550',
  Admin: '785238dd501e4544b3970f742b19b04a',
  LCOfficer: '81f985be6ef242018e17d574b3ab7c36',
  Executive: '8cf288415fa24a2b9a23ab768db43533',
  Communications: 'f8d3d9db43ca49aea716df742adffd02',
  Project: '8a47408f383c4aac9a8f2ba15195b191',
};

export const presetDates = {
  custom: 'Custom Filter',
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  thisYear: 'This Membership Year',
  lastYear: 'Last Membership Year',
};

export const transferChapterStatuses = {
  Initial: '894013f6f9a24710b850736f07438594',
  Pending: '1ebfa8c4d1954633bfa29339833fdd8f',
  Visit: '8b54a13336c040f788d4b926a0c4f286',
  Removed: '6190df3b5f14416ca50a04c8ee443026',
  Transferred: '155a713f82854c07819a533a22ebe158',
};

export const addressTypes = {
  Address: 'e874793f23c2465ebea8bb1adcc26711',
  Seasonal: '2341d1a1aa2b49a5aacec458c2c8f7b2',
};

export const reciprocityTypes = {
  Reciprocity: '008cc3371f564c0ea313b9f043600dc7',
  Group: '080eda7b567c44538b22630db356e335',
};

export const calculateDate = (preset) => {
  let startDate = new Date();
  let endDate = new Date();
  switch (preset) {
    case 'today':
      startDate = new Date();
      break;
    case 'yesterday':
      startDate = new Date(new Date().setDate(new Date().getDate() - 1));
      break;
    case 'thisWeek':
      startDate = new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay())
      );
      break;
    case 'thisMonth':
      startDate = new Date(new Date().setDate(1));
      break;
    case 'lastMonth':
      startDate = new Date(new Date().setMonth(new Date().getMonth() - 1, 1));
      break;
    case 'thisYear':
      // year start is actually March 1st - need to figure out if we are past that date
      // and if so keep the year the same otherwise go back a year
      if (new Date().getMonth() < 2) {
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 1, 2, 1)
        );
      } else {
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear(), 2, 1)
        );
      }
      break;
    case 'lastYear':
      // year start is actually March 1st - need to figure out if we are past that date
      // and if so go back a year otherwise go back 2 years
      if (new Date().getMonth() < 2) {
        endDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 1, 2, 1)
        );
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 2, 2, 1)
        );
      } else {
        endDate = new Date(
          new Date().setFullYear(new Date().getFullYear(), 2, 1)
        );
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 1, 2, 1)
        );
      }
      break;
    default:
      break;
  }

  return {
    startDate: startDate,
    endDate: endDate,
  };
};

export const getCalendarYearStart = () => {
  // Year start is actually March 1st - need to figure out if we are past that date
  const currentYear = new Date().getFullYear();
  if (new Date().getMonth() < 2) {
    return new Date(currentYear - 1, 2, 1); // March 1st of the previous year
  } else {
    return new Date(currentYear, 2, 1); // March 1st of the current year
  }
};

export const supportedReportFilters = [
  'spd_id',
  'chapter_id',
  'disbanded',
  'member_status',
  'inactive_start_date',
  'date_selector',
  'start_date',
  'end_date',
];

export const seekingTransfer = false;

export const test_frequecy = [
  {
    id: '566caf72c6ca40af8bb89e0dfe9e800f',
    name: 'Weekly',
  },
  {
    id: 'd912dc2c45054401a38daac314e7ae1c',
    name: 'Bi-Weekly',
  },
  {
    id: '8ab9371acaec45d7a3d72154f401dbd7',
    name: 'Monthly',
  },
];

export const days_of_week = [
  {
    id: '072cc0aabc844b7aad60c0e2437dda42',
    name: 'Sunday',
  },
  {
    id: 'ba44777b6720405392f2bfeae817d2cb',
    name: 'Monday',
  },
  {
    id: '8538aebaae4b4c9bbc23fdfb889ffc2a',
    name: 'Tuesday',
  },
  {
    id: '1802fa6bd2104dc3814ba4e9c659ba05',
    name: 'Wednesday',
  },
  {
    id: '08155763011e4dceaf3d65b9ef370af5',
    name: 'Thursday',
  },
  {
    id: '11d65c8ae2c74bd7abea06c5c3e9e625',
    name: 'Friday',
  },
  {
    id: 'f07ae738f0dc4b879dec61eb9d5bfe34',
    name: 'Saturday',
  },
];

export const times_of_day = [
  {
    id: '12:00',
    name: '12:00',
  },
  {
    id: '12:30',
    name: '12:30',
  },
  {
    id: '1:00',
    name: '1:00',
  },
  {
    id: '1:30',
    name: '1:30',
  },
  {
    id: '2:00',
    name: '2:00',
  },
  {
    id: '2:30',
    name: '2:30',
  },
  {
    id: '3:00',
    name: '3:00',
  },
  {
    id: '3:30',
    name: '3:30',
  },
  {
    id: '4:00',
    name: '4:00',
  },
  {
    id: '4:30',
    name: '4:30',
  },
  {
    id: '5:00',
    name: '5:00',
  },
  {
    id: '5:30',
    name: '5:30',
  },
  {
    id: '6:00',
    name: '6:00',
  },
  {
    id: '6:30',
    name: '6:30',
  },
  {
    id: '7:00',
    name: '7:00',
  },
  {
    id: '7:30',
    name: '7:30',
  },
  {
    id: '8:00',
    name: '8:00',
  },
  {
    id: '8:30',
    name: '8:30',
  },
  {
    id: '9:00',
    name: '9:00',
  },
  {
    id: '9:30',
    name: '9:30',
  },
  {
    id: '10:00',
    name: '10:00',
  },
  {
    id: '10:30',
    name: '10:30',
  },
  {
    id: '11:00',
    name: '11:00',
  },
  {
    id: '11:30',
    name: '11:30',
  },
];

export const months = [
  {
    id: '49f8bd874f1448eb8f4ec4153f5061c5',
    name: 'January',
  },
  {
    id: '1f9dc5e40df845e0b0a986abd7baefe0',
    name: 'February',
  },
  {
    id: 'bdb881b50e1a4393bdb863ed192f590d',
    name: 'March',
  },
  {
    id: '892e3a000fa94b9b8098513403a0a433',
    name: 'April',
  },
  {
    id: '2fb5b8dae5ef418c81b477d9fe122ee2',
    name: 'May',
  },
  {
    id: '8be492e9eb854922abc8609890535ab9',
    name: 'June',
  },
  {
    id: 'af8ba77828394d07a61e037ba88517a3',
    name: 'July',
  },
  {
    id: '7c1b6caedbaa4767bed246122fca25cb',
    name: 'August',
  },
  {
    id: '4236f50e18fc410e8924bf737d76eab8',
    name: 'September',
  },
  {
    id: 'c1a22ef2222842969eecda159d672b74',
    name: 'October',
  },
  {
    id: '10045ce54aaf484cb36e1810b0939b29',
    name: 'November',
  },
  {
    id: 'c9e23f562aa543e4bf2ae6a2e2801e9d',
    name: 'December',
  },
];

export const monthlyTimes = [
  {
    id: '3d9dde1499da482cadda1a503ae484de',
    name: '1st',
    type: 'monthly',
  },
  {
    id: '0d032d935b6d4e9e96b9d1567a0f09a2',
    name: '2nd',
    type: 'monthly',
  },
  {
    id: '443ef4bc156443d68e7305e38b8da7ee',
    name: '3rd',
    type: 'monthly',
  },
  {
    id: '4e4de181e76544df83bea7e522ef1583',
    name: '4th',
    type: 'monthly',
  },
  {
    id: '7e661dd663974b9892e1a750164cae98',
    name: '1st and 3rd',
    type: 'biweekly',
  },
  {
    id: '9f53145b0b3044ea9487d9538ab38df2',
    name: '2nd and 4th',
    type: 'biweekly',
  },
];

export const meetingFormats = [
  {
    id: 'befbf9d24f254882b678609c86880cf9',
    name: 'In-Person',
  },
  {
    id: 'd076e7db8e77473892263088e4f328cf',
    name: 'Virtual',
  },
  {
    id: '90aa631f3b714dd0b99c11593cf0af85',
    name: 'Hybrid',
  },
];
